import {config, mockResolveApiCall, requestOptions, requestTypes, sendRequest} from "../../Utilities/Api";
import {studentData} from "./studentMockData";

class ServerStudentApi {
    static getStudentDetails(studentId: string) {
        return sendRequest(
            requestOptions(config.URL + `students/${studentId}`,
                requestTypes.GET,
            ),
        );
    }

    static getOrganizations() {
        return sendRequest(
            requestOptions(`${config.URL}users/organizations/`,
                requestTypes.GET,
            )
        );
    }
}

//************************************************** MOCK API SERVER CALLS ****************************************

class MockStudentApi {
    static getStudentDetails() {
        return mockResolveApiCall( studentData[0], "");
    }

    static getOrganizations() {
        return mockResolveApiCall( [`Organization 1`], "");
    }
}

export const studentApi = config.environment.MODE === config.modes.SERVER ? ServerStudentApi : MockStudentApi;
